/**
 * Automatically attaches itself as a direct child of the body.
 * This allows for easy injection of floating views such as modals
 * or growl messages that do not rely on a specific container to render
 */
define('glu/core/modal/layerView',['require','../../layout','../../$'],function(require) {
    'use strict';

    var Layout = require('../../layout'),
        $ = require('../../$');


    return Layout.extend({
        className: 'glu-layer',
        template: function() {
            return '';
        },

        setTop: function(num) {
            this.$el.css('top', num + 'px');
        },

        height: function() {
            return this.$el.height();
        },

        position: function() {
            return this.$el.position();
        },

        setElement: function(element, delegate) {
            /*eslint "backbone/no-native-jquery": 0*/
            Layout.prototype.setElement.call(this, element, delegate);
            $('body').prepend(this.$el);
            // Don't know why this happen, but todo: research if really needed to prepend to entire body.
        }
    });

});

